import TeamMember from 'models/TeamMemberModel';

import { moveTeamMembers } from './types';

const moveTeamMembersReducerObject = {
  [moveTeamMembers.request]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['wizzardMoveTeamMembers', 'network', 'loading'], true)
        .setIn(['wizzardMoveTeamMembers', 'sourceTeamId'], action.sourceTeamId)
        .setIn(['wizzardMoveTeamMembers', 'targetTeamId'], action.targetTeamId)
        .setIn(['wizzardMoveTeamMembers', 'memberIds'], action.memberIds),
    ),
  [moveTeamMembers.success]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['wizzardMoveTeamMembers', 'network', 'loading'], false)
        .setIn(['wizzardMoveTeamMembers', 'network', 'error'], false)
        .setIn(
          ['wizzardMoveTeamMembers', 'updatedMember'],
          action.members.map((member) => TeamMember.deserialize(member)),
        ),
    ),
  [moveTeamMembers.failure]: (state, action) =>
    state.withMutations((s) =>
      s
        .setIn(['wizzardMoveTeamMembers', 'network', 'loading'], false)
        .setIn(['wizzardMoveTeamMembers', 'network', 'error'], action.error),
    ),
};

export default moveTeamMembersReducerObject;
